<template>
  <ThemeDefaultLayoutPage
    :breadcrumbs="modifiedBreadcrumbs"
    :title="section?.title"
    custom-padding="lg:!tw-py-11 !tw-py-6"
    :show-category="false"
  >
    <template v-if="articles.length > 0">
      <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-1 tw-gap-6 lg:tw-my-11 tw-mt-5 tw-mb-8"
      >
        <ThemeDefaultCardArticle
          v-for="item in articles"
          :key="`article-tag-${item._id}`"
          horizontal
          :published-at="item.publishedAt"
          :image="item.imageCover"
          :title="item.title"
          :description="item.shortDescription"
          :category-title="item.articleCategory.title"
          :path="getPath({ componentName: 'Article', slug: item.slug })"
          @click="eventArticleTag(item.title)"
        />
      </div>
      <Pagination v-model="page" :total="total" :per-page="perPage" />
    </template>
    <LandingNoData v-else />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  section,
  modifiedBreadcrumbs,
  articles,
  page,
  perPage,
  total,
  getPath,
  eventArticleTag,
} = await useTagArticlePage({ tagLabel: "แท็ก : " });
</script>
